import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';
import { ZoneContextManager } from '@opentelemetry/context-zone-peer-dep';
import {
  BatchSpanProcessor,
  ConsoleSpanExporter,
  SimpleSpanProcessor,
  WebTracerProvider,
} from '@opentelemetry/sdk-trace-web';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { CompositePropagator, W3CBaggagePropagator, W3CTraceContextPropagator } from '@opentelemetry/core';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { ATTR_DEPLOYMENT_ENVIRONMENT_NAME } from '@opentelemetry/semantic-conventions/incubating';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { AppInfo } from '../environment';

export const lightStepInitializer = (): Promise<void> => {
  return new Promise<void>((resolve) => {
    const { deploymentEnvironment, traceHeaderWhitelist, debug, serviceVersion, serviceName, accessToken } =
      AppInfo.Environment.lightStep;
    const tracerProvider = new WebTracerProvider({
      resource: resourceFromAttributes({
        [ATTR_DEPLOYMENT_ENVIRONMENT_NAME]: deploymentEnvironment,
        [ATTR_SERVICE_NAME]: serviceName,
        [ATTR_SERVICE_VERSION]: serviceVersion,
      }),
      spanProcessors: [
        ...(debug ? [new SimpleSpanProcessor(new ConsoleSpanExporter())] : []),
        new BatchSpanProcessor(
          new OTLPTraceExporter({
            url: 'https://ingest.lightstep.com/traces/otlp/v0.9',
            headers: { 'lightstep-access-token': accessToken },
          })
        ),
      ],
    });

    const contextManager = new ZoneContextManager();

    tracerProvider.register({
      contextManager,
      propagator: new CompositePropagator({
        propagators: [new W3CBaggagePropagator(), new W3CTraceContextPropagator()],
      }),
    });

    registerInstrumentations({
      tracerProvider,
      instrumentations: [
        getWebAutoInstrumentations({
          '@opentelemetry/instrumentation-document-load': {},
          '@opentelemetry/instrumentation-user-interaction': {},
          '@opentelemetry/instrumentation-fetch': {},
          '@opentelemetry/instrumentation-xml-http-request': {
            propagateTraceHeaderCorsUrls: [
              ...traceHeaderWhitelist,
              /^.*https:\/\/.*(domesticandgeneral\.com|athome\.domgen.*\.cloud|domgencloud\.net).*$/,
            ],
          },
        }),
      ],
    });

    resolve();
  });
};
